var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { space, fontSize, borderRadius } from 'styled-system';
import { applyVariations, getPaletteColor, deprecatedColorValue, deprecatedPropType, borderRadiusAttrs, } from '../utils';
var propTypes = __assign(__assign(__assign({ selected: PropTypes.bool }, space.propTypes), fontSize.propTypes), { color: deprecatedColorValue(), bg: deprecatedPropType('color') });
var ToggleBadge = styled.button.attrs(borderRadiusAttrs)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: ", ";\n  border: 0;\n  display: inline-block;\n  font-weight: ", ";\n  font-family: inherit;\n  cursor: pointer;\n  background-color: ", ";\n  color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n  ", "\n  ", " ", " ", ";\n"], ["\n  border-radius: ", ";\n  border: 0;\n  display: inline-block;\n  font-weight: ", ";\n  font-family: inherit;\n  cursor: pointer;\n  background-color: ", ";\n  color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n  ", "\n  ", " ", " ", ";\n"])), function (props) { return props.theme.radius; }, function (props) { return props.theme.bold; }, function (props) {
    return props.selected ? getPaletteColor(props.bg || props.color, 'light')(props) : props.unSelectedBg;
}, getPaletteColor('base'), function (props) { return getPaletteColor(props.bg || props.color, 'light')(props); }, applyVariations('ToggleBadge'), space, fontSize, borderRadius);
ToggleBadge.displayName = 'ToggleBadge';
ToggleBadge.propTypes = propTypes;
ToggleBadge.defaultProps = {
    borderRadius: 'full',
    selected: false,
    px: 2,
    py: 1,
    mx: 1,
    my: 1,
    fontSize: 0,
    color: 'primary',
    unSelectedBg: 'transparent',
};
export default ToggleBadge;
var templateObject_1;
//# sourceMappingURL=ToggleBadge.js.map